// Code for /cart page
import { updateCartIconBadge } from 'lib-utils'

document.addEventListener('nova:cartPage:refresh', () => {
  fetchCartItems();
  updateCartIconBadge();
});


async function fetchCartItems() {
  const sectionResponse = await fetch('/cart?section_id=inline-cart')
  const html = await sectionResponse.text()
  const doc = new DOMParser().parseFromString(html, 'text/html')

  const oldCart = document.querySelector('#CartPage');
  const newCart = doc.querySelector('#CartPage');

  oldCart.replaceWith(newCart);
}